import Button from '@carvana/ds-button';
import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';
import usePurchaseHeaderEvent from '|/hooks/use-purchase-header-event';
import styles from './purchase-header.module.css';
import ImpersonationBanner from '../../impersonation-baner';
import { OutageBanner } from '../../outage-banner';

const VehicleHeader: React.FC = () => {
  usePurchaseHeaderEvent();

  const saveAndExit = () => {
    sendNativeEvent({
      event: MobileWebviewEvents.SAVE_EXIT,
      payload: {
        screen: ''
      },
      source: 'purchase'
    });
  };

  return (
    <>
      <ImpersonationBanner />
      <OutageBanner />
      <header className={styles.header}>
        <div className={styles.nativeHeader}>
          <Button
            variant="tertiary"
            size="xs"
            icon={true}
            data-analytics-id="pp_vehicle_confirmation_header_back_button"
            className={styles.backButton}
            onClick={saveAndExit}
          >
            <ChevronLeft color="var(--icon-inverse)" />
          </Button>
        </div>
      </header>
    </>
  );
};

export default VehicleHeader;
